import { Card, CardBody } from "reactstrap";
import DataTable from "react-data-table-component";
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import AirHomeLoader from "./AirHomeLoader";
import Request from "../../helpers/request";
import { RefreshBtn } from "./button";

interface InterfaceDataTable {
  apiURL: string;
  columns: any;
  paramsId?: any;
  buttonformatJSON?: any;
  setTxCount?: any;
  setRxCount?: any;
  isReload?: boolean;
  setCmdCounts?: any;
  cmdList?: any;
}

function ReactDataTable({
  apiURL,
  columns,
  paramsId,
  buttonformatJSON,
  setTxCount,
  setRxCount,
  isReload,
  setCmdCounts,
  cmdList,
}: InterfaceDataTable) {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [totalRows, setTotalRows] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(10);
  const [goToPageInput, setGoToPageInput] = useState("1");
  const isFetchingRef = useRef(false);
  useEffect(() => {
    if (!data || !Array.isArray(data)) return;

    const counts: any = {};
    data?.forEach((item) => {
      try {
        const parsed = JSON.parse(item?.command);
        const cmd = parsed.cmd;
        const error = parsed.error;

        if (cmd) {
          counts[cmd] = (counts[cmd] || 0) + 1;
        } else {
          counts["NO CMD"] = (counts["NO CMD"] || 0) + 1;
        }
        if (error && error !== 0) {
          counts["ERROR"] = (counts["ERROR"] || 0) + 1;
        }
      } catch (e) {
        console.error("Invalid JSON in command:", item.command);
      }
    });

    setCmdCounts(counts);
  }, [data]);

  const fetchData = async (page: number, perPage: number) => {
    setLoading(true);

    if (isFetchingRef.current) {
      return;
    }

    isFetchingRef.current = true;

    try {
      const reqObj = {
        draw: 1,
        order: [],
        start: (page - 1) * perPage,
        length: perPage,
        search: {
          value: "",
          regex: false,
        },
        slave: paramsId?.slave || "",
      };

      const response = await Request.post(apiURL, reqObj);
      setData(response.data?.data || []);
      setTotalRows(response.data?.recordsTotal || 0);
    } catch (error: any) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        // clear local storage and reload
        localStorage.removeItem("userInfo");
        localStorage.removeItem("selectedPremiseID");
        localStorage.removeItem("selectedUserID");
        localStorage.removeItem("selectedUserEmail");
        localStorage.removeItem("Authorization");
        localStorage.removeItem("permissions");
        window.location.reload();
      }
    } finally {
      setLoading(false);
      isFetchingRef.current = false;
    }
  };

  const handleReload = () => {
    fetchData(page, perPage);
  };
  useEffect(() => {
    fetchData(page, perPage);
  }, [page, perPage, apiURL, isReload]);

  const totalPages = Math.ceil(totalRows / perPage);

  useEffect(() => {
    const txCount = data.filter(
      (row: any) =>
        row?.topic?.includes?.("/TX") || row?.topic?.includes?.("/g2m")
    ).length;

    const rxCount = data.filter(
      (row: any) =>
        row?.topic?.includes?.("/RX") || row?.topic?.includes?.("/m2g")
    ).length;

    setTxCount(txCount);
    setRxCount(rxCount);
  }, [data]);
  const handleGoToPage = () => {
    const numericValue = parseInt(goToPageInput, 10);
    if (
      !isNaN(numericValue) &&
      numericValue >= 1 &&
      numericValue <= totalPages
    ) {
      setPage(numericValue);
    }
  };

  return (
    <Card
      style={{
        marginTop: 30,
        marginLeft: 30,
        marginRight: 30,
        marginBottom: 0,
      }}
    >
      <CardBody>
        {loading && <AirHomeLoader />}
        {data?.length > 0 && (
          <div className="pb-3">
            <div className="d-flex flex-column flex-md-row flex-wrap justify-content-between align-items-center gap-3">
              {/* <h5
              className="modal-title"
              id="staticBackdropLabel"
              style={{ textAlign: "center" }}
            >
              {/* {"title"} */}
              {/* </h5> */}
              <div
                className="d-flex align-items-center justify-content-center gap-2"
                style={{ fontSize: "14px" }}
              >
                <span>Show</span>
                <select
                  id="custom-rows"
                  value={perPage}
                  onChange={(e) => {
                    const newPerPage = parseInt(e.target.value, 10);
                    const newTotalPages = Math.ceil(totalRows / newPerPage);
                    const clampedPage = Math.min(page, newTotalPages);
                    setPerPage(newPerPage);
                    setPage(clampedPage);
                    setGoToPageInput(clampedPage.toString());
                  }}
                  className="form-select form-select-sm mx-1"
                  style={{ width: "auto" }}
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
                <span>entries</span>
              </div>
              {cmdList}
              <div className="d-flex flex-wrap align-items-center justify-content-center gap-3">
                {buttonformatJSON}
                <RefreshBtn onClick={handleReload} loading={loading} />
              </div>
            </div>
          </div>
        )}

        <DataTable
          columns={columns}
          data={data}
          customStyles={customStyles}
          highlightOnHover
          noDataComponent="No records found."
        />
        {data?.length > 0 && (
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3 pt-3 pb-3 border-top">
            <span
              className="text-muted text-center text-md-start "
              style={{ fontSize: "12px", width: "300px" }}
            >
              Showing {(page - 1) * perPage + 1} to{" "}
              {Math.min(page * perPage, totalRows).toLocaleString()} of{" "}
              {totalRows.toLocaleString()} entries
            </span>

            <div className="d-flex flex-column flex-md-row align-items-center gap-2 w-100 justify-content-center justify-content-md-end">
              <div
                className="input-group input-group-sm"
                style={{ maxWidth: "180px" }}
              >
                <input
                  style={{ fontSize: "14px", padding: "6px 10px" }}
                  type="number"
                  min={1}
                  max={totalPages}
                  className="form-control"
                  placeholder="page"
                  value={goToPageInput}
                  onChange={(e) => {
                    const value = e.target.value;
                    const numericValue = parseInt(value, 10);

                    if (value === "") {
                      setGoToPageInput("");
                    } else if (
                      !isNaN(numericValue) &&
                      numericValue <= totalPages
                    ) {
                      setGoToPageInput(value);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      const value = e.currentTarget.value;
                      if (value !== "") {
                        handleGoToPage();
                      }
                    }
                  }}
                />
                <span className="input-group-text">/ {totalPages}</span>
                <button
                  className="btn btn-dark"
                  onClick={handleGoToPage}
                  style={{ fontSize: "14px", padding: "6px 10px" }}
                >
                  Go to
                </button>
              </div>

              {/* Pagination */}
              <nav>
                <ul
                  className="pagination mb-0 flex-wrap"
                  style={{ fontSize: "14px" }}
                >
                  <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => {
                        if (page > 1) {
                          setPage(page - 1);
                          setGoToPageInput((page - 1).toString());
                        }
                      }}
                    >
                      Prev
                    </button>
                  </li>

                  <li className={`page-item ${page === 1 ? "active" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => {
                        setPage(1);
                        setGoToPageInput("1");
                      }}
                    >
                      1
                    </button>
                  </li>

                  {page > 3 && totalPages > 5 && (
                    <li className="page-item disabled">
                      <span className="page-link">...</span>
                    </li>
                  )}

                  {(() => {
                    let middlePages = [];

                    if (page <= 3) {
                      middlePages = [2, 3, 4];
                    } else if (page >= totalPages - 2) {
                      middlePages = [
                        totalPages - 3,
                        totalPages - 2,
                        totalPages - 1,
                      ];
                    } else {
                      middlePages = [page - 1, page, page + 1];
                    }

                    return middlePages
                      .filter((p) => p > 1 && p < totalPages)
                      .map((p) => (
                        <li
                          key={p}
                          className={`page-item ${page === p ? "active" : ""}`}
                        >
                          <button
                            className="page-link"
                            onClick={() => {
                              setPage(p);
                              setGoToPageInput(p.toString());
                            }}
                          >
                            {p}
                          </button>
                        </li>
                      ));
                  })()}

                  {page < totalPages - 2 && totalPages > 5 && (
                    <li className="page-item disabled">
                      <span className="page-link">...</span>
                    </li>
                  )}

                  {totalPages > 1 && (
                    <li
                      className={`page-item ${
                        page === totalPages ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => {
                          setPage(totalPages);
                          setGoToPageInput(totalPages.toString());
                        }}
                      >
                        {totalPages}
                      </button>
                    </li>
                  )}

                  <li
                    className={`page-item ${
                      page === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => {
                        if (page < totalPages) {
                          setPage(page + 1);
                          setGoToPageInput((page + 1).toString());
                        }
                      }}
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        )}
      </CardBody>
    </Card>
  );
}

export default ReactDataTable;

export const customStyles: any = {
  tableWrapper: {
    style: {
      minWidth: "1100px",
    },
  },
  subHeader: {
    style: {
      padding: "0px",
      margin: "0px",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#EFF2F7",
      fontWeight: "bold",
      fontSize: "14px",
      borderBottom: "none",
    },
  },
  rows: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
  cells: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
};
